<!-- Botão de voltar -->
<ng-container *transloco="let t">
  @if (routerLink || emitEvent) {
    <div
      class="flex items-center"
      >
      <button
        mat-icon-button
        [attr.tabindex]="tabindex"
        (click)="doClick()">
        <mat-icon svgIcon="heroicons_outline:arrow-long-left"></mat-icon>
      </button>
      {{  showLabel ? ((labelTranslate ? t(label) : label) | titlecase) : '' }}
    </div>
  }
</ng-container>
